export default {
    name: 'global-loader',
}
